// We use superagent as a default worker
import SuperAgentResource, { SuperagentResponse } from './superagent';

// import SingleObjectResource factory
import makeSingle from './single';

// Export everything
export var GenericResource = SuperAgentResource;
export var Resource = makeSingle(SuperAgentResource);
export var Response = SuperagentResponse;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/generic.js
// module id = 840
// module chunks = 0